var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable prettier/prettier */
/**
 * 缺省页组件
 * @author sunzhiguang
 * @date 2020/8/10
 */
import React, { useMemo } from 'react';
import { Empty as AntdEmpty } from 'antd';
function Empty(props) {
    var image = props.image, refreshNode = props.refreshNode, description = props.description, style = props.style, className = props.className, keyword = props.keyword;
    var buttonNode = useMemo(function () {
        if (refreshNode) {
            return refreshNode;
        }
        return null;
    }, [refreshNode]);
    var emptyProps = useMemo(function () {
        return {
            image: image,
            description: description,
            imageStyle: {
                width: '140px',
                height: '140px',
                marginBottom: '20px',
            },
        };
    }, [image, description]);
    var emptyContainerStyle = {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        userSelect: 'none',
    };
    return (React.createElement("div", { className: className || '', style: __assign(__assign({}, emptyContainerStyle), (style || {})) },
        React.createElement(AntdEmpty, __assign({}, emptyProps)),
        keyword && (React.createElement("div", { style: { display: 'inline-flex' } },
            "\"",
            React.createElement("div", { className: "color-primary" }, keyword),
            "\"")),
        buttonNode));
}
export default Empty;
//# sourceMappingURL=index.js.map